import React from 'react';
import PropTypes from 'prop-types';
import { endpoints } from './constants';
import { InsertMacrosDialog } from '../../../content-edit-controls';

const InsertEmailMacrosDialogWindow = ({
  onSave,
  onCancel,
  params
}) =>
{
  const { index, macros } = params;
  const { macrosEndpoint: endpoint } = endpoints;

  const handleSave = (macros) =>
  {
    onSave({ macros, index });
  };

  return (
    <InsertMacrosDialog
      endpoint={endpoint}
      macros={macros}
      onSave={handleSave}
      onCancel={onCancel}
    />
  );
};

InsertEmailMacrosDialogWindow.propTypes = {
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  params: PropTypes.shape({
    macros: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired
};

export default InsertEmailMacrosDialogWindow;